module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/management-c1b94b0f41b964e912c4ba4824b90b2e.png";